module.exports = __webpack_public_path__ + "img/tu05.3ccadcbe.jpg";